import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step7Consent: React.FC = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="solar-form-section">
      <div className="solar-form-checkbox-group">
        <label htmlFor="contactConsent" className="solar-form-checkbox-label">
          <input
            type="checkbox"
            id="contactConsent"
            {...register('contactConsent')}
            className="solar-form-checkbox"
          />
          <span>
            I consent to being contacted by a solar energy consultant regarding my inquiry.
            This may include phone calls, emails, or text messages.
          </span>
        </label>
        {errors.contactConsent && (
          <p className="solar-form-error">
            {String(errors.contactConsent.message)}
          </p>
        )}
      </div>

      {/* Honeypot field */}
      <div className="hidden">
        <input
          type="text"
          id="companyName"
          {...register('companyName')}
          className="solar-form-input"
        />
      </div>
    </div>
  );
};

export default Step7Consent;
